import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import {Link} from 'react-router';
import dateFormat from 'dateformat';

import {SliderHelpers} from '../../../../../../../helpers';

class ModuleSlider extends Component {

    render() {


        const { params, modules, hasAccess } = this.props,
            settings = SliderHelpers.getResponsiveSliderSettings();


        return (

            <section className="row course-module-slider">
                <div className="col-xs-12 module-slider items-slider">
                    <h4 className="h4 brand-color">Modules</h4>
                    <Slider {...settings}>
                        {
                            Object.keys(modules).map((module, index) => {
                            return (
                                <div className="item-slide background-image" key={ index }>

                                    <div className="text-box color-mask">

                                        <h6 className="h6 item-title white">{ modules[module].name }</h6>

                                        <h6 className="h6 item-title white">{ dateFormat(modules[module].start_date, 'fullDate') }</h6>

                                        {
                                            hasAccess !== undefined &&
                                            <ul className="buttons-left pos-bottom">
                                                <li>

                                                    <Link className="btn btn-primary btn-block"
                                                            to={ `/training/interactive-webinars/${ params.webinarId }/series/${ params.seriesId }/module/${ modules[module].id }` }>
                                                        <span className="label">View Module </span><span className="icon"><i
                                                        className="fa fa-angle-right animated-right"> </i></span></Link>
                                                </li>
                                            </ul>
                                        }


                                    </div>
                                </div>
                            );
                        }) }
                    </Slider>
                </div>

            </section>
        );

    }

}

ModuleSlider.propTypes = {
    params: PropTypes.object.isRequired,
    modules: PropTypes.array.isRequired,
};

export default ModuleSlider;


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/ModuleSlider.js